import useHelper from "~/utils/helper";

export default function (user: any, nuxtContext: any) {
  const { checkScopes } = useHelper()

  if (user && !checkScopes(nuxtContext, ['verified'])) {
    nuxtContext.app.router.push(nuxtContext.localePath('/email-verification?verify=1'))
  }
}
